/* eslint-disable indent */
import { REGISTER_RESULT_STATUSES, ROLES } from 'constant';
import { getHighestRoles } from '.';

// eslint-disable-next-line import/prefer-default-export
export const checkPermissionForRegisterResult = (status) => {
  const highestRole = getHighestRoles();
  switch (status) {
    case REGISTER_RESULT_STATUSES.SUBMITTED:
      return highestRole === ROLES.INSTITUSIONAL_SPECIALIST;
    case REGISTER_RESULT_STATUSES.INSTITUTIONAL_SPECIALIST_REVIEW:
      return highestRole === ROLES.SPECIALIST;
    case REGISTER_RESULT_STATUSES.SPECIALIST_REVIEW:
      return highestRole === ROLES.DEPARTMENT_LEADER;
    default:
      return false;
  }
};
